import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { HttpRequestService } from '~shared/servicios/HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  private readonly urlTriidyNotifications = `${environment.apiTriidyUrlNotifications}`;

  constructor(
    private httpRequestService: HttpRequestService,
    private http: HttpClient
  ) { }

  public executeGetQuery<T>(params: any, url: string, endpoint?: string) {
    return this.http.get<T>(`${url}${endpoint ? endpoint : ''}`, { params });
  }

  getNotificationsService(
    user: string
  ): Observable<any> {
    return this.executeGetQuery<any>(
      '',
      `${this.urlTriidyNotifications}/api`,
      `/DeskNotifications/desk-notification-by-user/${user}`
    )
      .pipe(
        map(
          (resp) => {
            return resp;
          },
          (err: any) => {
            console.warn(err);
          }
        )
      );
  }
  getMarkNotificationsService(
    idNotification: number
  ): Observable<any> {
    return this.executeGetQuery<any>(
      '',
      `${this.urlTriidyNotifications}/api`,
      `/DeskNotifications/mark-as-read/${idNotification}`
    )
      .pipe(
        map(
          (resp) => {
            return resp;
          },
          (err: any) => {
            console.warn(err);
          }
        )
      );
  }
}
